// src/utils/haptics.js
//
// Hafif dokunsal geri bildirim (haptic). IG-tarzı jestlerde "canlı" his verir.
// Android Chrome navigator.vibrate'i destekler; iOS Safari desteklemez →
// sessizce yok sayılır (feature-detect). Tamamen opsiyonel/eklemeli: hiçbir
// mantığı değiştirmez, sadece kısa titreşim tetikler.

const supported =
  typeof navigator !== "undefined" && typeof navigator.vibrate === "function";

// Kullanıcı hareket azaltmayı tercih ettiyse haptiği de kıs (saygı).
function reducedMotion() {
  try {
    return (
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  } catch (_) {
    return false;
  }
}

// `navigator.vibrate` imzasıyla aynı: tek süre veya süre dizisi.
function buzz(pattern: number | number[]) {
  if (!supported || reducedMotion()) return;
  try {
    navigator.vibrate(pattern);
  } catch (_) {
    /* desteklenmiyor/engelli → sessiz */
  }
}

// Hafif dokunuş (kart geçişi, nokta, sekme) — çok kısa.
export const tapHaptic = () => buzz(8);
// Seçim/onay (sheet kapanışı, jest tetikleme).
export const selectHaptic = () => buzz(12);
// Başarı (çift dokunuş puan, gönderildi) — kısa çift titreşim.
export const successHaptic = () => buzz([10, 35, 16]);

export default { tapHaptic, selectHaptic, successHaptic };
